import VForm from '@/vuetify_custom/v-form'
import { mapGetters } from 'vuex'
import { VBtn, VCard, VCardTitle, VCardText, VIcon } from 'vuetify/lib'
import VTable from '@/vuetify_custom/v-table/v3'
import {contract_broad_types, balance_types} from '@/libs/conctract_utils.js'
import ViewerItem from '@/views/components/viewer/item_v1.vue';
import VPopDel from './v-pop-del'
import styles from './index.module.less'
import VPopSelect from '@/vuetify_custom/v-pop-select.vue'
import {contract_types_mixins} from './EditMixIns.jsx'
// Textareas_Field
import { createlinkContractsParams } from '../utils'
import { common_mixins } from './EditMixIns.jsx'
import { contract_select_search } from '../service'
export default {
    mixins:[common_mixins, contract_types_mixins],
    data() {
        return {
            hash: {},
        }
    },
    computed: {
        ...mapGetters({
            contract_types_hash: 'async/contract_types_hash',
        }),
        table_fields() {
            const _this = this
            return [
                {
                    text: '合同编号',
                    align: 'center',
                    value: 'uid',
                    width: 150,
                    value_key: '',
                },
                {
                    text: '合同名称',
                    align: 'center',
                    value: '1',
                    width: 200,
                    render(_, __) {
                        if (!__.uid) {
                            return '-'
                        }
                        const current = _this.hash[__.id] || {}
                        return current.name
                    }
                },
                {
                    text: '合同类别',
                    align: 'center',
                    value: '2',
                    width: 150,
                    // contract_types_hash
                    render(_, __) {
                        if (!__.uid) {
                            return '-'
                        }
                        const current = _this.hash[__.id] || {}
                        const contract_type_id = current.contract_type_id
                        const contract_type = _this.contract_types_hash[contract_type_id] 
                        if (!contract_type) {
                            return '-'
                        }
                        const main_type = contract_broad_types.getName(contract_type.main_type)
                        const balance_type = balance_types.getName(contract_type.balance_type)
                        
                        return `${balance_type}-${main_type}-${contract_type.sub_type}`
                    }
                },
                {
                    text: '操作',
                    align: 'center',
                    type: 'button_g_field',
                    value: 'action',
                     width: 120,
                     fixed: 'right',
                    render: (_, __, index) => {
                        if (_this.params.virtual_contract_type === 1) {
                            return 
                        }
                      
                        return <div>
                            <VPopDel
                                title="确定删除该条数据？"
                                on={{
                                    submit:() => {
                                        _this.params.link_contracts.splice(index, 1)
                                    }
                                }}
                            />
                    
                        </div>
                    }
                }
            ]
        },
        fields() {
            return [
                {
                    key:'table',
                    cols: 12,
                },
            ]
        }
    },
    methods: {
        setHash(item = {}) {
            if (Object.keys(item).length < 3) {
                return
            }
            this.hash[item.id] = item
            if (!this.params.draft_link_contracts) {
                this.params.draft_link_contracts = {}
            }
            this.params.draft_link_contracts[item.id] = item
        },
        changeUid(item, index) {
            this.$set(this.params.link_contracts, index, {id:item.id, uid:item.uid})
            this.setHash(item)
        },
    },
    render() {
        const _this = this
        return <div class={styles['block-margin']}>
        <VCard flat light outlined>
            <VCardTitle>
                关联合同
                {this.params.virtual_contract_type !== 1 && <VBtn class={styles['btn-f']} 
                    outlined
                    color="primary"
                    small
                    on={{
                        click:() => {
                            // createlinkContractsParams
                            if (!_this.params.link_contracts) {
                                _this.params.link_contracts = []
                            }
                            _this.params.link_contracts.push(createlinkContractsParams())
                        }
                    }}
                    >
                    添加合同
                </VBtn>}
                {_this.params.virtual_contract_type === 1 &&
                 (!_this.params.link_contracts || _this.params.link_contracts.length === 0) && 
                 <span style="margin-left:10px;color:red;font-size:0.9rem">[请先选择需关联的主合同信息！]</span>}
            </VCardTitle>
            <VCardText>
            <VForm
                ref="base"
                fields={_this.fields}
                scopedSlots={{
                    table:() => {
                        return <VTable
                            headers={this.table_fields}
                            desserts={this.params.link_contracts}
                            scopedSlots={{
                                uid:(value, target, index) => { 
                                    
                                    return <VPopSelect
                                    text = ''
                                    placeholder=''
                                    disabled={_this.is_generate_from_contract_child}
                                    outList={_this.params.link_contracts}
                                    url={contract_select_search}
                                    handleSearch={({contracts = []} = {}) => {
                                           return contracts
                                    }}
                                    rules={[val => {
                                        if (_this.params.virtual_contract_type === 1) {
                                            return !!val || '请选择需关联的主合同'
                                        }  
                                        return true
                                    }]}
                                    scopedSlots={{
                                        'append-outer':() => {
                                            return <div style={{
                                                display: value ? 'block' : 'none' 
                                               }}>
                                                   <ViewerItem
                                                        type='Contract'
                                                        modelId={target.id || 0}
                                                    >
                                               <VBtn icon color='primary'>
                                                    <VIcon >mdi-details</VIcon>
                                               </VBtn>
                                           </ViewerItem>
                                               </div> 
                                        }
                                    }}
                                   //rules={[commonValidateRuleGo]}
                                    contentHeigh={400}
                                    on={{
                                        change(item) {
                                            _this.changeUid(item, index)
                                            if (_this.params.virtual_contract_type === 1) {
                                                _this.$emit('handleFromMain', item)
                                            }
                                        }
                                    }}
                                    render = {
                                        (h, item) => {
                                            return <div>
                                                <p class={styles['p-c']}>
                                                    {item.uid}
                                                </p>
                                                <p class={styles['p-c']}>
                                                    {item.name}
                                                </p>
                                                <p class={styles['p-c']}>
                                                    {item.fill_user}
                                                </p>
                                            </div>
                                        }
                                    }
                                    valueRender={() => {
                                 
                                        return target && target.uid || ''
                                    }}
                                />
                                }
                            }}
                        />
                    }
                }}
            />
            </VCardText>
        </VCard>
    </div>
    }
}